import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CfmViewFormService } from 'src/app/services/cfm-view-form.service';
import { CfmModelComponent } from './cfm-model/cfm-model.component';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-cfm-view-form',
  templateUrl: './cfm-view-form.component.html',
  styleUrls: ['./cfm-view-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CfmViewFormComponent implements OnInit {

  surveyGuid: any = '';
  cfmSurvey: any = '';
  surveyQuestions: any = '';
  customerEffort: any = '';
  customerAnswer: any = '';
  customerAnswerMulti: any[] = [];
  customerReasonComments: any = '';
  customerExperience: any = '';
  showQuestions: boolean = false;
  feedbackSuccess: boolean = false;
  showComments: boolean = false;
  feedbackDiv: boolean = false;
  answers: any[] = [];
  selectedRating: any = '';
  selectedQuestions: any[] = [];
  oprtion: any;

  constructor(private CFMS: CfmViewFormService, private modalController: ModalController,
    private UTS: UtilitiesService) {
    if (!this.UTS.getCookie("cfm")) {
      this.CFMS.getCFMData().subscribe(response => {
        this.cfmSurvey = response;
        this.surveyQuestions = this.cfmSurvey.questions;
        if (this.isMobileView()) {
          this.surveyQuestions = this.cfmSurvey.questionsApp;
        } 
      });
    }

  }

  isMobileView() {
    let view = 'web';
    let mobileViewFlag = false;
    view = this.UTS.getENV();
    mobileViewFlag = view == 'mobile' ? true : false;
    return mobileViewFlag;
  }

  ngOnInit() {
  }

  clickCustomerExperience(experienceGuid, questionGuid) {
    this.customerExperience = experienceGuid
    this.answers[0] = {
      "questionGuid": questionGuid,
      "answerGuid": experienceGuid
    };
    this.surveyQuestions[0].answers?.option?.forEach(option => {
      this.oprtion = option;
      if (this.customerExperience == option.optionGUID) {
        this.selectedRating = option.rating;
      }
    });
    this.surveyQuestions[2].answers?.option?.forEach(option => {
      if (this.selectedRating < 4 && option.title == 'predefinedTextForLowRating') {
        this.selectedQuestions = option.option;
      } else if (this.selectedRating > 3 && option.title == 'predefinedTextForHighRating') {
        this.selectedQuestions = option.option;
      }
    });

    this.openCfmModel(CfmModelComponent);
  }

  async openCfmModel(component: any) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { customerExperience: this.customerExperience, cfmSurvey: this.cfmSurvey, surveyQuestions: this.surveyQuestions, answers: this.answers },
      cssClass: 'verification-modal modal-fullscreen',
    });
    modal.onWillDismiss().then((response) => {

      if (response.data == true) {
        this.feedbackSuccess = true;
      }

    });


    return await modal.present();
  }
}
